var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconDiamond = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117.377,
    height: 117.377,
    viewBox: "0 0 117.377 117.377",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -13.19, 17.189)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "color-change",
    cx: 58.688,
    cy: 58.688,
    r: 58.688,
    fill: "#000",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 17.189, -13.19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.665 25.926L37.5 14.494a.9.9 0 0 0-.764-.424H18.761a.915.915 0 0 0 0 1.829h2l-5.522 8.808L9.714 15.9H12.2a.915.915 0 0 0 0-1.829H8.07a.9.9 0 0 0-.764.425L.141 25.926a.924.924 0 0 0-.029.931.892.892 0 0 0 .091.124.22.22 0 0 0 .02.037l21.5 24.939a.9.9 0 0 0 1.363 0l21.5-24.942.01-.019a.92.92 0 0 0 .072-1.069zm-16.3 1.4L22.4 48.078l-5.444-18.955a.9.9 0 0 0-1.121-.623.916.916 0 0 0-.616 1.134l5.168 17.995-17.5-20.3zM16.881 25.5l5.519-8.809 5.525 8.809zm13.367 1.829h9.288a.915.915 0 0 0 0-1.829h-8.323l5.522-8.808 6.041 9.635-18.359 21.3zM35.092 15.9l-5.522 8.808-5.523-8.808zm-27.022.791l5.522 8.809H2.548zm7.574-2.622a.915.915 0 0 1 0 1.829h-.408a.915.915 0 0 1 0-1.829zM21.5 7.754V.915a.9.9 0 1 1 1.808 0v6.839a.9.9 0 1 1-1.808 0zm5.318 2.765a.922.922 0 0 1 0-1.294L31.6 4.391a.9.9 0 0 1 1.279 0 .922.922 0 0 1 0 1.294L28.1 10.52a.9.9 0 0 1-1.279 0zM11.931 5.682a.921.921 0 0 1-.275-.9.909.909 0 0 1 .66-.668.9.9 0 0 1 .892.278l4.779 4.836a.922.922 0 0 1 0 1.294.9.9 0 0 1-1.279 0z",
    transform: "translate(36.287 32.553)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDiamond, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconDiamond.ee68995e.svg";
export { ForwardRef as ReactComponent };